import { demoHoursLeft } from "@bt/domain";
import { FlaskConicalIcon, RotateCcwIcon, XCircleIcon } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { EndDemoDialog, ResetDemoDialog } from "@/features/account/demo";
import { useMe } from "@/lib/account";

/**
 * In a visitor's demo garage (public demo, ADR 0012): how long it has left, with "Reset demo
 * data" and "End demo now". Shows for nobody else.
 */
export function DemoBanner() {
  const { t } = useTranslation();
  const { data: me } = useMe();
  const [resetting, setResetting] = useState(false);
  const [ending, setEnding] = useState(false);
  const demo = me?.demo;
  if (!demo?.garage) return null;

  return (
    <section
      aria-label={t("demo.banner")}
      className="flex flex-col gap-1 border-b border-border bg-brand-soft px-4 py-2 text-sm sm:flex-row sm:items-center sm:gap-3 md:px-6"
    >
      <p className="flex min-w-0 flex-1 items-center gap-2 py-1 font-medium text-brand-fg">
        <FlaskConicalIcon className="size-4 shrink-0" aria-hidden />
        <span>
          {t("demo.banner")} ·{" "}
          {t("demo.deletedIn", { hours: demoHoursLeft(demo.expiresAt, new Date()) })}
        </span>
      </p>
      <div className="-mx-2 flex flex-wrap items-center gap-1 sm:mx-0">
        <Button variant="ghost" size="sm" onClick={() => setResetting(true)}>
          <RotateCcwIcon />
          {t("demo.reset")}
        </Button>
        <Button variant="ghost" size="sm" onClick={() => setEnding(true)}>
          <XCircleIcon />
          {t("demo.end")}
        </Button>
      </div>
      <ResetDemoDialog open={resetting} onOpenChange={setResetting} />
      <EndDemoDialog open={ending} onOpenChange={setEnding} />
    </section>
  );
}
